import cn from 'classnames'

import toast, { Toast, ToastBar, Toaster } from 'react-hot-toast'

import AlertIcon from 'src/icons/alert.svg'
import CloseIcon from 'src/icons/close.svg'
import InfoIcon from 'src/icons/info.svg'
import SuccessIcon from 'src/icons/success.svg'

import { ExtendedToastOptions } from '../model/types'
import cls from './styles.module.scss'
import { useMediaQuery } from 'src/lib/use-media-query'

const CloseButton = ({ id }: { id: string }) => (
    <button
        aria-label="close"
        className={cls.close_btn}
        onClick={() => toast.dismiss(id)}
    >
        <img src={CloseIcon} alt="CloseIcon" className="toast-icon" />
    </button>
)

export const ToasterComponent = () => {
    const isMobile = useMediaQuery('(max-width: 1024px)')

    return (
        <Toaster
            toastOptions={{ className: 'toast', duration: 2 * 1000 }}
            containerClassName={'toast-container'}
            position={isMobile ? 'top-center' : 'top-right'}
        >
            {(toast: Toast & ExtendedToastOptions) => {
                switch (toast.type) {
                    case 'success':
                        return (
                            <div
                                className={cn(
                                    cls.root,
                                    toast.visible ? cls.show : cls.hide
                                )}
                            >
                                <div className={cls.icon_container}>
                                    <img
                                        src={SuccessIcon}
                                        alt="SuccessIcon"
                                        className="toast-icon"
                                    />
                                </div>
                                <div className={cls.content}>
                                    <p
                                        className={cn(
                                            cls.label,
                                            cls.success_label
                                        )}
                                    >
                                        {toast.title ?? 'Success'}
                                    </p>
                                    <p className={cls.message}>
                                        {toast.message as string}
                                    </p>
                                </div>
                                <div className={cls.close_container}>
                                    <CloseButton id={toast.id} />
                                </div>
                            </div>
                        )
                    case 'error':
                        return (
                            <div
                                className={cn(
                                    cls.root,
                                    toast.visible ? cls.show : cls.hide
                                )}
                            >
                                <div className={cls.icon_container}>
                                    <img
                                        src={AlertIcon}
                                        alt="AlertIcon"
                                        className="toast-icon"
                                    />
                                </div>
                                <div className={cls.content}>
                                    <p
                                        className={cn(
                                            cls.label,
                                            cls.error_label
                                        )}
                                    >
                                        {toast.title ?? 'Error'}
                                    </p>
                                    <p className={cls.message}>
                                        {toast.message as string}
                                    </p>
                                </div>
                                <div className={cls.close_container}>
                                    <CloseButton id={toast.id} />
                                </div>
                            </div>
                        )
                    case 'loading':
                        return (
                            <div
                                className={cn(
                                    cls.root,
                                    toast.visible ? cls.show : cls.hide
                                )}
                            >
                                <div className={cls.icon_container}>
                                    <img
                                        src={InfoIcon}
                                        alt="InfoIcon"
                                        className="toast-icon"
                                    />
                                </div>
                                <div className={cls.content}>
                                    <p
                                        className={cn(
                                            cls.label,
                                            cls.loading_label
                                        )}
                                    >
                                        {toast.title ?? 'Pending'}
                                    </p>
                                    <p className={cls.message}>
                                        {toast.message as string}
                                    </p>
                                </div>
                                <div className={cls.close_container}>
                                    <CloseButton id={toast.id} />
                                </div>
                            </div>
                        )
                    default:
                        return <ToastBar toast={toast} />
                }
            }}
        </Toaster>
    )
}
